/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// Webpacker dependencies
import 'core-js'
import 'regenerator-runtime/runtime'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
Rails.start()
ActiveStorage.start()

require('jquery')
require('masonry-layout') // check if needed
require('@rails/actiontext')
require("cleave.js")

// track user events
//import posthog from 'posthog-js'

// CSS
import "tailwindcss/tailwind.css"
import "stylesheets/components/_buttons"
import "tailwindcss/utilities"
import "@tailwindcss/forms"
import "@tailwindcss/aspect-ratio"
import '../stylesheets/style.scss';

import '../src/jquery.are-you-sure';
//import '../src/jquery.bootstrap-select.min';
import '../src/jquery.dirtyforms';
import '../src/jquery.fileinput';
import '../src/jquery.metadata';
import '../src/jquery.migrate';
import '../src/jquery.mousewheel';
import '../src/jquery.nestedform';
import '../src/jquery.rrssb.min';

// required for carousel
import 'swiper/swiper-bundle.min.css'


import '../src/application_steps.js';

//import '../src/datatables/datatables.js';
//import '../src/datatables/datatables.js.coffee.erb';

// import Flatpickr
import Flatpickr from 'stimulus-flatpickr'
// Import style for flatpickr
require("flatpickr/dist/flatpickr.css")

import '../src/form/form';
import '../src/tenant/tenant.js';

// if the request url contains localhost or stagiung, enable this
// if (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('staging') > -1) {
//     posthog.init('phc_FSRlVLSEf9hsosiISq0ZDdwSsCMrRhUKXGZNJddcLcB', { api_host: 'https://eu.posthog.com' })
// }

//if (window.location.href.indexOf('localhost') === -1 && window.location.href.indexOf('staging') === -1) {
//    posthog.init('phc_FSRlVLSEf9hsosiISq0ZDdwSsCMrRhUKXGZNJddcLcB', { api_host: 'https://eu.posthog.com' })
//}




$(document).on('turbo:load', function() {



});

$(document).on('turbo:destroy', function() {

});


// Stimulus
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
const application = Application.start()
const context = require.context("../controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

// Import and register all TailwindCSS Components
import { Alert, Autosave, Dropdown, Modal, Tabs, Popover, Toggle, Slideover } from "tailwindcss-stimulus-components"
application.register('alert', Alert)
application.register('tdropdown', Dropdown)
application.register('modal', Modal)
application.register('toggle', Toggle)
application.register('slideover', Slideover)

// Import AutoComplete
// https://github.com/afcapel/stimulus-autocomplete
import { Autocomplete } from 'stimulus-autocomplete/src/autocomplete'
application.register('autocomplete', Autocomplete)

import ReadMore from "stimulus-read-more"
application.register("read-more", ReadMore)

// Hotwire
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo